import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import './index.css';
import App from './App';

Sentry.init({
  dsn: "https://6cb0ac9c392037ec965817e0ce2693c2@o4509388949356544.ingest.us.sentry.io/4510889620275200",
  sendDefaultPii: true
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
